import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const EnquiryCatalogContainer = styled.div`
  background-color: #d1e6f7;
  margin: 1rem 0;
  padding: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.375rem;
`;

export const CatalogContiner = styled.div`
  margin-top: 10px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
`;

export const CatalogServiceOption = styled.span`
  color: #0a4986;
  font-weight: bold;
`;
export const CatalogServiceOptionCount = styled.span`
  color: #474747;
  font-style: italic;
`;

export const styles = {
  iconCloseButton: {
    backgroundColor: "transparent",
    border: "none",
    height: "auto",
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  closeButton: {
    color: "#333",
    background: "#fff",
    border: "1px solid #ccc",
    "&:hover": {
      backgroundColor: "#ccc",
    },
  },
  submitButton: {
    color: "white",
    background: "#1BACE4",
    border: "1px solid #1BACE4",
    marginRight: "5px",
    "&:hover": {
      backgroundColor: "#1589b6",
    },
  },
};

export const ErrorMessage = styled.p`
  color: red;
  font-size: 16px;
  font-family: "Lato";
  line-height: 1;
  margin: 0 16px 0 0;
  padding: 0;
  max-width: 54%;
  display: inline-block;
`;

export const EnquiryTitle = styled.h2`
  font-size: 14px;
  font-weight: 700;
  margin: 0;
  font-family: "Lato";
  color: #00aeea;
  margin: 0rem 0 1rem 0;
  line-height: 1;
  text-transform: initial;
`;

export const APIErrorMEssage = styled.span`
  ${fontStyles}
  color: red;
`;

export const CurrencyBanner = styled.div`
  background: #f08046;
  display: flex;
`;

export const ExchangeRateLabel = styled.span`
  display: flex;
  padding: 8px;
  color: ${(props) => props?.color ?? "#fff"};
`;

export const ExchangeRateWrapper = styled.div`
  background: white;
  display: flex;
  justify-content: space-between;
`;

export const ExchangeContainer = styled.div`
  background: #f08046;
  width: 100%;
  padding: 10px 1rem;
`;
